import MarqueeCarouselImage from "@/assets/images/marquee-carousel-1.png";
import { SuccessStoryType } from "@/shared/types/common.types";
import { Typography } from "@graphy/ui";
import classNames from "classnames";
import Image from "next/image";

const HomeMarqueeCard = ({
  successStory,
  direction,
}: {
  successStory: SuccessStoryType;
  direction: "TOP" | "BOTTOM";
}) => {
  return (
    <div className="group/card pointer-events-none relative mx-3 flex w-[278px] flex-col sm:w-[400px]">
      <div
        className={classNames(
          "pointer-events-auto relative flex flex-grow flex-col gap-4 border border-grey-2 bg-grey-1 p-6 transition group-hover/card:bg-purple-0",
          {
            "rounded-b-xl rounded-t-xl group-hover/card:rounded-b-none":
              direction === "BOTTOM",
            "rounded-b-xl rounded-t-xl group-hover/card:rounded-t-none":
              direction === "TOP",
          }
        )}
      >
        <div
          className={classNames(
            // `invisible absolute -z-10 h-full w-full bg-grey-3 opacity-0 transition-[inset] duration-1000 group-hover/card:visible group-hover/card:z-30 group-hover/card:h-64 group-hover/card:opacity-100`,
            `absolute left-0 -z-[1] w-full overflow-hidden bg-grey-3`,
            `transition-all duration-200`,
            `invisible group-hover/card:visible`,
            `h-full group-hover/card:h-64`,
            // `opacity-0 group-hover/card:opacity-100`,
            // `-z-10 group-hover/card:z-30`,
            {
              "top-0 rounded-b-xl rounded-t-xl group-hover/card:top-full group-hover/card:rounded-t-none":
                direction === "BOTTOM",
              "bottom-0 origin-bottom rounded-b-xl rounded-t-xl group-hover/card:bottom-full group-hover/card:rounded-b-none":
                direction === "TOP",
            }
          )}
        >
          <Image
            src={successStory.image || MarqueeCarouselImage}
            fill
            style={{
              objectFit: "cover",
              height: "100%",
              width: "100%",
            }}
            alt={`${successStory.name}'s website`}
          />
        </div>
        <div className="flex items-center gap-2">
          <div className="relative h-9 w-9 overflow-hidden rounded-full bg-grey-4">
            <Image
              src={successStory.avatar || MarqueeCarouselImage}
              alt={`${successStory.name}'s avatar`}
              fill
            />
          </div>
          <div className="flex flex-1 flex-col">
            <Typography
              size="BODY"
              fontWeight="font-semibold"
              colorClass="text-grey-4"
            >
              {successStory.name}
            </Typography>
            <Typography size="CAPTION" colorClass="text-grey-4">
              {successStory.designation} | {successStory.company}
            </Typography>
          </div>
          <div className="flex flex-col text-right">
            <Typography
              size="CAPTION"
              colorClass="text-purple-3"
              fontWeight="font-semibold"
            >
              {successStory.highlight.main}
            </Typography>
            <Typography size="FOOTNOTE" colorClass="text-grey-3">
              {successStory.highlight.subtext}
            </Typography>
          </div>
        </div>
        <Typography
          size="BODY"
          fontWeight="font-semibold"
          colorClass="text-grey-4"
        >
          {successStory.description}
        </Typography>
      </div>
    </div>
  );
};

export default HomeMarqueeCard;
